import DOMPurify from "dompurify";
import { normalizePostLinkHrefs } from "./normalizePostLinkHrefs";

const RICH_ALLOWED_TAGS = [
	"a",
	"p",
	"br",
	"b",
	"strong",
	"i",
	"em",
	"u",
	"s",
	"ul",
	"ol",
	"li",
	"h1",
	"h2",
	"h3",
	"blockquote",
	"span",
	"div",
	"img",
	"pre",
	"code",
];

const LINK_ALLOWED_ATTR = [
	"href",
	"membermentionid",
	"class",
	"target",
	"rel",
	"id",
];

const RICH_ALLOWED_ATTR = [
	...LINK_ALLOWED_ATTR,
	"src",
	"alt",
	"width",
	"height",
	"style",
	"title",
];

export const sanitizePostHtml = (html: string, rich: boolean): string =>
	DOMPurify.sanitize(normalizePostLinkHrefs(html), {
		ALLOWED_TAGS: rich ? RICH_ALLOWED_TAGS : ["a"],
		ALLOWED_ATTR: rich ? RICH_ALLOWED_ATTR : LINK_ALLOWED_ATTR,
	});
